<script>
import { Bar, mixins } from 'vue-chartjs'

export default {
  extends: Bar,
  name: 'BarChart',
  mixins: [mixins.reactiveProp],
  data() {
    return {
      legendHtml: '',
      primaryColor: '#76BF43',
      secondaryColor: '#D7009D',
      existingLegend: [],
      isLoaded: false,
      data: {},
      chartOptions: {
        barValueSpacing: 20,
        animation: {
          duration: 500,
          easing: 'easeInOutSine'
        },
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              barPercentage: 1,
              categoryPercentage: 0.1,
              scaleLabel: {
                display: true,
                labelString: 'Score'
              },
              ticks: {
                suggestedMax: 5
              }
            }
          ],
          xAxes: [
            {
              barPercentage: 1,
              categoryPercentage: 0.2,
              stacked: true,
              maxBarThickness: 50
            }
          ]
        },
        scaleOverride: true,
        scaleStepWidth: 2,
        scaleStartValue: 0,
        legend: {
          display: true,
          position: 'top',
          fullWidth: true,
          labels: {
            boxWidth: 15
          }
        },
        legendCallback: function() {
          return '<div>LEGEND</div>'
        },
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 0,
            bottom: 0
          }
        },
        plugins: {
          datalabels: {
            display: false
          }
        }
      }
    }
  },
  watch: {
    chartData() {
      this.$data._chart.update()
    }
  },
  computed: {
    sampChartData() {
      let chartObj = {
        labels: [
          ['Cyber', '12/18/89'],
          ['Cyber', '12/18/89'],
          ['Cyber', '12/18/89'],
          ['Cyber', '12/18/89'],
          ['Cyber', '12/18/89']
        ],
        datasets: [
          {
            label: 'Pre Quiz Correct',
            backgroundColor: this.primaryColor,
            stack: 1,
            data: [1, 4, 5, 5, 3]
          },
          {
            label: 'Pre Quiz Incorrect',
            stack: 1,
            backgroundColor: this.secondaryColor,
            data: [9, 6, 5, 5, 7]
          },
          {
            label: 'Post Quiz Correct',
            backgroundColor: this.primaryColor,
            stack: 2,
            data: [5, 6, 5, 5, 7]
          },
          {
            label: 'Post Quiz Incorrect',
            stack: 2,
            backgroundColor: this.secondaryColor,
            data: [5, 4, 5, 5, 3]
          }
        ]
      }
      return chartObj
    },
    filterLegend() {
      // return [...new Set(this.chartData.datasets.map((this.x = this.x.label)))]
      return 0
    }
  },
  mounted() {
    this.renderChart(this.chartData, this.chartOptions)
    this.generateLegend()
  },
  methods: {
    updateChart() {
      setTimeout(() => {
        this.$data._chart.update()
        this.renderChart(this.chartData, this.chartOptions)
      }, 100)
    }
  }
}
</script>

<style lang="scss" scoped></style>
